export default {
  // Common
  common: {
    welcome: 'Bienvenido',
    logout: 'Cerrar sesión',
    users: 'Usuarios',
    order: 'Pedido',
    orders: 'Pedidos',
    orderCount: '{{count}} pedido(s)',
    comingSoon: 'Esta página estará disponible pronto',
    shipments: 'Envíos',
    fleet: 'Flota',
    languageUpdateError: 'Error al actualizar el idioma',
    save: 'Guardar',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    search: 'Buscar',
    filter: 'Filtrar',
    reset: 'Restablecer',
    resetFilters: 'Restablecer filtros',
    back: 'Volver',
    next: 'Siguiente',
    contents: 'Índice',
    previous: 'Anterior',
    submit: 'Enviar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    yes: 'Sí',
    no: 'No',
    optional: 'Opcional',
    required: 'Requerido',
    dashboard: 'Panel',
    settings: 'Configuraciones',
    view: 'Ver',
    download: 'Descargar',
    actions: 'Acciones',
    details: 'Detalles',
    noData: 'No hay datos disponibles',
    weight: 'Peso',
    weightUnit: 'kg',
    pallets: 'Paletas',
    price: 'Precio',
    priceUnit: '€',
    contact: 'Contacto',
    phone: 'Teléfono',
    email: 'Correo',
    address: 'Dirección',
    publish: 'Publicar',
    follow: 'Seguir',
    accept: 'Aceptar',
    decline: 'Rechazar',
    accepting: 'Aceptando...',
    declining: 'Rechazando...',
    confirming: 'Confirmando...',
    all: 'Todos',
    active: 'Activos',
    pending: 'Pendientes',
    completed: 'Completados',
    pickup: 'Recogida',
    delivery: 'Entrega',
    route: 'Ruta',
    date: 'Fecha',
    time: 'Hora',
    status: 'Estado',
    cargo: 'Carga',
    trailer: 'Remolque',
    driver: 'Conductor',
    vehicle: 'Vehículo',
    company: 'Empresa',
    name: 'Nombre',
    firstName: 'Nombre',
    lastName: 'Apellido',
    description: 'Descripción',
    instructions: 'Instrucciones',
    notes: 'Notas',
    message: 'Mensaje',
    amount: 'Cantidad',
    shipper: 'Remitente',
    transporter: 'Transportista',
    admin: 'Administrador',
  },

  // Auth
  auth: {
    welcomeTitle: 'Bienvenido a Velox',
    login: {
      title: 'Iniciar sesión',
      subtitle: 'Inicia sesión o crea una cuenta para acceder a tu plataforma TMS',
      email: 'Correo',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      submit: 'Acceder',
      loading: 'Accediendo...',
      success: '¡Sesión iniciada con éxito!',
      error: 'Credenciales incorrectas',
      fillAllFields: 'Por favor completa todos los campos',
    },
    signup: {
      title: 'Registrarse',
      email: 'Correo',
      password: 'Contraseña',
      confirmPassword: 'Confirmar contraseña',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      companyName: 'Nombre de la empresa',
      companyType: 'Tipo',
      shipper: 'Remitente',
      transporter: 'Transportista',
      registrationNumber: 'ID Fiscal',
      registrationNumberPlaceholder: 'Ej: NIF, CIF, IVA...',
      registrationNumberVerifying: 'Verificando...',
      registrationNumberValid: '✓ Número válido',
      registrationNumberInvalid: '✗ Número inválido',
      registrationNumberExists: '⚠️ Esta empresa ya está registrada',
      countryCode: 'País',
      countryCodePlaceholder: 'FR',
      verified: 'Verificado',
      alreadyExists: 'Ya registrado',
      verifying: 'Verificando...',
      iban: 'IBAN',
      ibanPlaceholder: 'ES91 2100 0418 4502 0005 1332',
      ibanRequired: 'El IBAN es obligatorio',
      foundedDate: 'Fecha de fundación de la empresa',
      foundedDateRequired: 'La fecha de fundación de la empresa es obligatoria',
      acceptTerms: 'Acepto las Condiciones Generales de Uso y la Política de Privacidad',
      acceptTermsPart1: 'Acepto las',
      termsLink: 'Condiciones Generales de Uso',
      acceptTermsPart2: 'y la',
      privacyLink: 'Política de Privacidad',
      termsRequired: 'Debe aceptar las Condiciones Generales de Uso',
      submit: 'Crear cuenta',
      loading: 'Creando...',
      success: '¡Cuenta creada con éxito!',
      error: 'Error al crear la cuenta',
      fillRequired: 'Por favor completa todos los campos obligatorios',
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordLength: 'La contraseña debe tener al menos 6 caracteres',
    },
    resetPassword: {
      title: 'Restablecer contraseña',
      subtitle: 'Introduce tu correo para recibir un enlace de restablecimiento',
      email: 'Correo',
      submit: 'Enviar enlace',
      loading: 'Enviando...',
      success: '¡Correo de restablecimiento enviado!',
      error: 'Error al enviar el correo',
      backToLogin: 'Volver al ingreso',
      enterEmail: 'Por favor introduce tu correo',
    },
    newPassword: {
      title: 'Nueva contraseña',
      subtitle: 'Elige una nueva contraseña segura para tu cuenta',
      password: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      placeholder: '••••••••',
      submit: 'Actualizar contraseña',
      loading: 'Actualizando...',
      success: 'Contraseña actualizada con éxito',
      error: 'Error al actualizar la contraseña',
      mismatch: 'Las contraseñas no coinciden',
      tooShort: 'La contraseña debe tener al menos 8 caracteres',
      invalidToken: 'Este enlace de restablecimiento es inválido o ha expirado. Por favor solicita uno nuevo.',
      invalidTokenTitle: 'Enlace inválido',
      backToLogin: 'Volver al ingreso',
    },
  },

  // Dashboard
  dashboard: {
    header: {
      shipper: 'Panel de Remitente',
      transporter: 'Panel de Transportista',
      driver: 'Mis Misiones',
      admin: 'Panel de Administración',
    },
    stats: {
      totalOrders: 'Total de pedidos',
      activeOrders: 'Pedidos activos',
      activeOrdersLabel: 'En curso',
      draftOrders: 'Borradores',
      deliveredOrders: 'Entregados',
      pendingBids: 'Ofertas pendientes',
      completedOrders: 'Pedidos completados',
      totalRevenue: 'Ingresos totales',
      activeDrivers: 'Conductores activos',
      availableDrivers: 'Conductores disponibles',
      availableVehicles: 'Vehículos disponibles',
      ongoingMissions: 'Misiones en curso',
      activeMissions: 'Misiones activas',
      completedMissions: 'Misiones completadas',
      assignedMissions: 'Asignadas',
      totalTransporters: 'Total de transportistas',
      totalDrivers: 'Total de conductores',
      totalCommands: 'Total de pedidos',
      unpaidPayments: 'Pagos pendientes',
    },
    emptyState: {
      noOrders: 'No hay pedidos por ahora',
      noOrdersInProgress: 'No hay pedidos en curso',
      noActiveMissions: 'No hay misiones activas',
      noMissions: 'No hay misiones por ahora',
      noAssignedMissions: 'No hay misiones asignadas',
      noCompletedMissions: 'No hay misiones completadas',
      noBids: 'No hay ofertas por ahora',
      noInProgress: 'No hay pedidos en curso',
      viewAllOrders: 'Ver todos mis pedidos',
    },
    pendingReservations: {
      title: 'Reservas pendientes de confirmación',
      subtitle: '{{count}} transportista(s) han reservado tus pedidos',
      subtitles: ' ha',
      subtitlep: ' han',
    },
    ordersInProgress: {
      title: 'Pedidos en curso',
      subtitle: 'Tus pedidos asignados y en tránsito',
    },
    activeMissions: {
      title: 'Misiones activas',
      noMissions: 'No hay misiones activas',
      consultMarketplace: 'Consulta el marketplace para reservar misiones',
    },
    createOrder: 'Crear pedido',
  },

  // Orders
  orders: {
    title: 'Mis Pedidos',
    noCoordinates: 'Coordenadas faltantes',
    print: {
      title: 'Formulario de pedido',
      button: 'Descargar',
      printButton: 'Imprimir',
      generating: 'Generando...',
      printing: 'Imprimiendo...',
      success: 'Imagen generada',
      downloaded: 'Formulario de pedido descargado con éxito',
      error: 'Error',
      elementNotFound: 'No se puede encontrar el contenido para capturar',
      generationFailed: 'Error al generar la imagen',
      qrNotGenerated: 'Código QR no generado',
      pickupInfo: '📦 Información de recogida',
      deliveryInfo: '🚚 Información de entrega',
      cargoInfo: '📋 Carga',
      additionalInstructions: '⚠️ Instrucciones adicionales',
      notSpecified: 'No especificado',
      title_field: 'Título:',
      vehicleType: 'Tipo de vehículo:',
      volume: 'Volumen:',
      platformDescription: 'VELOX - Plataforma de Gestión Logística',
      generatedOn: 'Documento generado el',
    },
    subtitle: 'Gestiona todos tus pedidos por estado',
    create: 'Crear pedido',
    createNew: '+ Crear pedido',
    filterByStatus: 'Filtrar por estado',
    filterDescription: 'Selecciona un estado para ver los pedidos correspondientes',
    selectStatus: 'Seleccionar estado',
    orderNumber: 'Número de pedido',
    statuses: {
      all: 'Todos',
      draft: 'Borrador',
      posted: 'Publicado',
      booked: 'Reservado',
      assigned: 'Asignado',
      in_transit: 'En tránsito',
      delivered: 'Entregado',
      cancelled: 'Cancelado',
      drafts: 'Borradores',
      posted_plural: 'Publicados',
      booked_plural: 'Reservados',
      assigned_plural: 'Asignados',
      in_transit_plural: 'En tránsito',
      delivered_plural: 'Entregados',
      cancelled_plural: 'Cancelados',
    },
    statusDescriptions: {
      draft: 'Pedido en creación',
      posted: 'Pedido publicado en marketplace',
      booked: 'Solicitud aceptada, esperando asignación de conductor/vehículo',
      assigned: 'Conductor y vehículo asignados',
      in_transit: 'Pedido en tránsito',
      delivered: 'Pedido entregado con éxito',
      cancelled: 'Pedido cancelado',
    },
    status: {
      draft: 'Borrador',
      posted: 'Publicado',
      booked: 'Reservado',
      assigned: 'Asignado',
      inTransit: 'En tránsito',
      delivered: 'Entregado',
      cancelled: 'Cancelado',
    },
    statusLabels: {
      pending: 'Pendiente de confirmación',
      accepted: 'Aceptada',
      assigned: 'Asignada',
    },
    emptyStates: {
      all: 'No hay pedidos por ahora',
      draft: 'Ningún borrador',
      posted: 'Ningún pedido publicado',
      booked: 'Ningún pedido reservado',
      assigned: 'Ningún pedido asignado',
      in_transit: 'Ningún pedido en tránsito',
      delivered: 'Ningún pedido entregado',
      cancelled: 'Ningún pedido cancelado',
    },
    priceValidated: 'Precio confirmado',
    priceProposed: 'Precio propuesto',
    myOffers: 'Mis ofertas',
    reservationPending: 'Reserva pendiente',
    confirmation: 'Confirmación',
    refusal: 'Rechazo',
    yourPreviousOfferDeclined: 'Tu oferta anterior fue rechazada',
    declinedOn: 'Rechazada el',
    yourPendingOffer: 'Tu oferta pendiente',
    proposedAmount: 'Cantidad propuesta',
    submittedOn: 'Enviado el',
    bookFixedPrice: 'Reservar a precio fijo',
    makeOffer: 'Hacer una oferta',
    makeNewOffer: 'Hacer nueva oferta',
    offerPendingResponse: 'Oferta pendiente de respuesta',
    cancel: 'Cancelar',
    confirmCancel: '¿Deseas realmente cancelar la misión {{orderNumber}}?',
    cancelSuccess: 'Misión cancelada con éxito',
    cancelError: 'Error al cancelar la misión',
    transporter: 'Transportista',
    statusLabel: 'Estado',
    pickupDate: 'Fecha de recogida',
    pickupLocation: 'Lugar de recogida',
    deliveryDate: 'Fecha de entrega',
    deliveryLocation: 'Lugar de entrega',
    weight: 'Peso',
    price: 'Precio',
    trailerType: 'Tipo de remolque',
    form: {
      title: 'Crear pedido',
      subtitle: 'Completa la información de tu transporte',
      priceRequired: 'Precio propuesto obligatorio para publicar el pedido',
    },
    card: {
      order: 'Pedido',
      validatedPrice: 'Precio confirmado',
      proposedPrice: 'Precio propuesto',
      weight: 'Peso',
      pallets: 'paletas',
      boxes: 'cajas',
      euroPallets: 'euro-paletas',
      publish: 'Publicar',
      myOffers: 'Mis ofertas',
      track: 'Rastrear',
      details: 'Detalles',
    },
    details: {
      title: 'Detalles completos del pedido',
      proposedPrice: 'Precio propuesto',
      cargo: 'Carga',
      cargoTitle: 'Título:',
      cargoDescription: 'Descripción:',
      cargoImage: 'Foto de la carga',
      startImages: 'Fotos de recogida',
      deliveryImages: 'Fotos de entrega',
      weight: 'Peso:',
      pallets: 'Paletas:',
      boxes: 'Cajas:',
      euroPallets: 'Euro-paletas:',
      volume: 'Volumen:',
      type: 'Tipo:',
      route: 'Ruta',
      pickup: 'Recogida:',
      delivery: 'Entrega:',
      transporterInfo: 'Información del transportista',
      company: 'Empresa',
      assignedDriver: 'Conductor asignado',
      vehicle: 'Vehículo',
      plateNumber: 'Matrícula',
      licenseNumber: 'Licencia',
      trailerType: 'Tipo de remolque',
      specialInstructions: 'Instrucciones especiales',
      visibleMarketplace: '✓ Visible en el marketplace',
      edit: 'Editar',
      print: 'Imprimir',
      delete: 'Eliminar',
      close: 'Cerrar',
      confirmDelete: 'Confirmar eliminación',
      confirmDeleteText:
        '¿Estás seguro de que deseas eliminar el pedido {{orderNumber}}? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      deleteSuccess: 'Pedido eliminado exitosamente',
      deleteError: 'Error al eliminar el pedido',
    },
    messages: {
      publishedSuccess: '¡Pedido publicado con éxito!',
      publishError: 'Error al publicar el pedido',
    },
  },

  // Bids
  bids: {
    title: 'Ofertas',
    offersReceived: 'Ofertas recibidas',
    offersReceivedCount: 'Ofertas recibidas ({{count}})',
    viewBids: 'Ver ofertas',
    noBids: 'No hay ofertas por ahora',
    noBidsReceived: 'No hay ofertas recibidas por ahora',
    newBid: 'Nueva oferta',
    amount: 'Cantidad',
    proposedAmount: 'Cantidad propuesta',
    message: 'Mensaje',
    submit: 'Enviar oferta',
    accept: 'Aceptar',
    decline: 'Rechazar',
    accepted: 'Aceptada',
    declined: 'Rechazada',
    pending: 'Pendiente',
    receivedOn: 'Recibida el',
    orderDetails: 'Detalles del pedido',
    acceptBid: 'Aceptar',
    declineBid: 'Rechazar',
  },

  // Marketplace
  marketplace: {
    title: 'Marketplace',
    subtitle: 'Encuentra pedidos disponibles',
    filters: 'Filtros',
    trailerType: 'Tipo de remolque',
    allTypes: 'Todos los tipos',
    departureCity: 'Ciudad de salida',
    departureCityPlaceholder: 'Ej: Madrid',
    arrivalCity: 'Ciudad de llegada',
    arrivalCityPlaceholder: 'Ej: Barcelona',
    availabilityDate: 'Fecha de disponibilidad',
    selectDate: 'Seleccionar fecha',
    sortByDistance: 'Ordenar por distancia',
    noSort: 'Sin ordenar',
    sortAsc: 'Más cercano primero',
    sortDesc: 'Más lejano primero',
    resetFilters: 'Restablecer filtros',
    searchOrders: 'Buscar pedidos...',
    sortBy: 'Ordenar por',
    sortNewest: 'Más recientes',
    sortPrice: 'Precio',
    sortDistance: 'Distancia',
    noOrders: 'No hay pedidos disponibles',
    loadMore: 'Cargar más',
    pickupLocation: 'Lugar de recogida',
    deliveryLocation: 'Lugar de entrega',
    weight: 'Peso',
    vehicleType: 'Tipo de vehículo',
    price: 'Precio',
    messages: {
      applicationSent: 'Tu candidatura ha sido enviada con éxito',
    },
    errors: {
      applicationError: 'Error al enviar la candidatura',
    },
    card: {
      pickup: 'Recogida',
      delivery: 'Entrega',
      weight: 'Peso:',
      pallets: 'Paletas:',
      declinedBid: 'Tu oferta anterior fue rechazada',
      declinedAmount: 'Cantidad:',
      declinedOn: 'Rechazada el',
      pendingBid: 'Tu oferta pendiente',
      proposedAmount: 'Cantidad propuesta',
      message: 'Mensaje',
      submittedOn: 'Enviado el',
      bookFixed: 'Reservar a precio fijo',
      bidPending: 'Oferta pendiente de respuesta',
      makeNewBid: 'Hacer nueva oferta',
      makeBid: 'Hacer oferta',
      applying: 'Enviando...',
      applyForOrder: 'Solicitar este pedido',
    },
    placeBid: 'Hacer una oferta',
    viewDetails: 'Ver detalles',
    bookOrder: 'Reservar pedido',
    bookingSuccess: 'Misión reservada con éxito',
    bookingError: 'Error al reservar la misión',
  },

  // Fleet
  fleet: {
    title: 'Gestión de la flota',
    subtitle: 'Gestiona tus vehículos y conductores',
    vehicles: 'Vehículos',
    drivers: 'Conductores',
    wizard: {
      step1: 'Paso 1: Tipo de vehículo',
      step2: 'Paso 2: Fotos de la tarjeta de circulación',
      step3: 'Paso 3: Información del vehículo',
      step1Description: 'Selecciona el tipo de vehículo',
      step2Description: 'Sube fotos (opcional)',
      step3Description: 'Completa la información',
    },
    extraction: {
      analyzing: 'Analizando...',
      analyzingFront: 'Analizando anverso...',
      analyzingBack: 'Analizando reverso...',
      success: 'Datos extraídos con éxito',
      frontComplete: 'Anverso analizado',
      backComplete: 'Reverso analizado',
      successDesc: 'La información del vehículo se ha rellenado automáticamente',
      error: 'Error de extracción',
      errorDesc: 'No se pudieron extraer los datos. Por favor, complete manualmente.',
      step1: 'Paso 1/2: Anverso',
      step2: 'Paso 2/2: Reverso',
      optional: 'Fotos opcionales:',
      optionalDesc: 'Puedes tomar fotos de la tarjeta de circulación para rellenar automáticamente los campos, o introducir la información manualmente.',
      notRegistrationCard: 'Documento no reconocido',
      notRegistrationCardDesc: 'Esta imagen no parece ser un permiso de circulación. Toma una foto clara de un permiso válido.',
    },
    dialogs: {
      addVehicle: 'Añadir vehículo',
      editVehicle: 'Editar vehículo',
      captureRegistration: 'Fotografiar Tarjeta de Circulación',
      captureRegistrationFront: 'Tarjeta de Circulación - Frente',
      captureRegistrationBack: 'Tarjeta de Circulación - Reverso',
      inviteDriver: 'Invitar conductor',
      editDriver: 'Editar conductor',
      vehicleType: 'Tipo de vehículo',
      plateNumber: 'Matrícula',
      plateNumberPlaceholder: 'Ej: AB-123-CD',
      vin: 'Número VIN',
      vinPlaceholder: 'Ej: 1HGBH41JXMN109186',
      brand: 'Marca',
      brandPlaceholder: 'Ej: Iveco',
      model: 'Modelo',
      modelPlaceholder: 'Ej: Daily',
      year: 'Año',
      yearPlaceholder: 'Ej: 2020',
      lastMaintenance: 'Último mantenimiento',
      lastMaintenancePlaceholder: 'Seleccionar una fecha',
      nextMaintenance: 'Próximo mantenimiento',
      nextMaintenancePlaceholder: 'Seleccionar una fecha',
      status: 'Estado',
      email: 'Correo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      licenseNumber: 'Número de licencia',
      licenseExpiry: 'Fecha de expiración de licencia',
      select: 'Seleccionar',
      selectType: 'Seleccionar tipo',
      selectVehicleType: 'Seleccionar un tipo',
      required: '*',
      cancel: 'Cancelar',
      add: 'Añadir',
      addingVehicle: 'Añadiendo vehículo...',
      save: 'Guardar',
      sendInvitation: 'Enviar invitación',
      statusAvailable: 'Disponible',
      statusOnMission: 'En misión',
      statusOffDuty: 'Fuera de servicio',
    },
    invitations: 'Invitaciones',
    myVehicles: 'Mis vehículos',
    myDrivers: 'Mis conductores',
    addVehicle: 'Añadir vehículo',
    addDriver: '+ Invitar conductor',
    inviteDriver: 'Invitar conductor',
    addFirstVehicle: 'Añade tu primer vehículo',
    inviteFirstDriver: 'Invita a tu primer conductor',
    noVehicles: 'No hay vehículos registrados',
    noDrivers: 'No hay conductores registrados',
    noInvitations: 'No hay invitaciones',
    pendingInvitations: 'Invitaciones pendientes',
    activeDrivers: 'Conductores activos',
    vehicleDetails: {
      brand: 'Marca',
      model: 'Modelo',
      year: 'Año',
      plateNumber: 'Matrícula',
      type: 'Tipo',
      status: 'Estado',
      available: 'Disponible',
      unavailable: 'No disponible',
      inUse: 'En uso',
      onMission: 'En misión',
      maintenance: 'Mantenimiento',
      lastMaintenance: 'Último mantenimiento',
      nextMaintenance: 'Próximo mantenimiento',
      vin: 'VIN:',
      modelLabel: 'Modelo:',
      nextMaintenanceLabel: 'Próximo mantenimiento:',
    },
    driverDetails: {
      name: 'Nombre',
      email: 'Correo',
      phone: 'Teléfono',
      license: 'Licencia',
      licenseNumber: 'Número de licencia',
      licenseExpiry: 'Expiración de licencia',
      status: 'Estado',
      available: 'Disponible',
      onMission: 'En misión',
      offDuty: 'Fuera de servicio',
      unavailable: 'No disponible',
      noName: 'Conductor sin nombre',
      licenseExpiresOn: 'Licencia expira el',
      position: 'Posición',
      positionUnavailable: 'Posición no disponible',
      addedOn: 'Añadido el',
    },
    invitationDetails: {
      email: 'Correo electrónico',
      phone: 'Teléfono',
      pending: 'Pendiente',
      expired: 'Expirada',
      expires: 'Expira',
      sentOn: 'Invitación enviada el',
    },
    cancelInvitation: 'Cancelar invitación',
    cancelInvitationTitle: 'Cancelar invitación',
    cancelInvitationDescription: '¿Está seguro de que desea cancelar la invitación de {{name}} ({{email}})? Esta acción es irreversible.',
    confirmCancel: 'Sí, cancelar',
    invitationDeleted: 'Invitación cancelada',
    invitationDeletedDescription: 'La invitación se ha eliminado correctamente',
    invitationDeleteError: 'No se puede eliminar la invitación',
    resendEmail: 'Reenviar correo',
    emailResent: 'Correo reenviado',
    emailResentDescription: 'El correo de invitación ha sido reenviado a {{email}}',
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
      cancel: 'Cancelar',
    },
    deleteDialog: {
      vehicleTitle: 'Eliminar vehículo',
      vehicleDescription: '¿Estás seguro de que deseas eliminar el vehículo',
      driverTitle: 'Eliminar conductor',
      driverDescription: '¿Estás seguro de que deseas eliminar',
      irreversible: 'Esta acción no se puede deshacer.',
    },
    documentStatus: {
      verified: 'Verificado',
      unverified: 'No verificado',
      expired: 'Caducado',
      expiringSoon: 'Caduca pronto',
      registrationCard: 'Permiso de circulación',
      driverLicense: 'Carnet de conducir',
      scanRegistration: 'Escanear permiso de circulación',
      scanLicense: 'Escanear carnet',
      rescan: 'Volver a escanear',
      lockedField: 'Bloqueado (verificado por OCR)',
    },
    license: {
      title: 'Verificación del carnet',
      howTo: 'Cómo hacerlo:',
      howToDesc: 'Toma una foto del anverso y reverso del carnet. Los datos se extraerán y bloquearán automáticamente.',
      front: 'Anverso del carnet',
      back: 'Reverso del carnet',
      captureFront: 'Capturar anverso',
      captureBack: 'Capturar reverso',
      frontDone: 'Anverso analizado',
      backDone: 'Reverso analizado',
      extracted: 'Datos extraídos',
      extractedData: 'Datos del carnet',
      lockedNotice: 'Estos campos serán bloqueados y no se podrán editar manualmente.',
      categories: 'Categorías',
      save: 'Guardar carnet',
      saved: 'Carnet guardado',
      savedDesc: 'El carnet ha sido verificado y guardado.',
      incomplete: 'Datos incompletos',
      incompleteDesc: 'El número y fecha de caducidad son obligatorios.',
      notALicense: 'Documento no reconocido',
      notALicenseDesc: 'Esta imagen no parece ser un carnet de conducir. Toma una foto clara de un carnet válido.',
    },
  },

  // Missions
  missions: {
    title: 'Mis Misiones',
    myMissions: 'Mis Misiones',
    subtitle: 'Gestiona tus misiones de transporte',
    all: 'Todas',
    pending: 'Pendientes',
    upcoming: 'Próximas',
    ongoing: 'En curso',
    active: 'Activas',
    completed: 'Completadas',
    assigned: 'Asignadas',
    search: 'Buscar por número, ciudad o dirección...',
    noResults: 'Ninguna misión coincide con tu búsqueda',
    resultFound: 'resultado encontrado',
    resultsFound: 'resultados encontrados',
    noMissions: 'No hay misiones',
    noMissionPending: 'No hay misiones pendientes',
    noMissionActive: 'No hay misiones activas',
    noMissionCompleted: 'No hay misiones completadas',
    filters: {
      title: 'Filtros',
      trailerType: 'Tipo de remolque',
      distance: 'Distancia',
      allTrailers: 'Todos los tipos',
      allDistances: 'Todas las distancias',
      distance0to100: 'Menos de 100 km',
      distance100to500: '100 - 500 km',
      distance500to1000: '500 - 1000 km',
      distance1000plus: 'Más de 1000 km',
      clearFilters: 'Limpiar filtros',
    },
    assignDriver: 'Asignar conductor',
    assignVehicle: 'Asignar vehículo',
    startMission: 'Iniciar misión',
    completeMission: 'Completar misión',
    orderNumber: 'Número de pedido',
    pickup: 'Recogida',
    delivery: 'Entrega',
    status: 'Estado',
    accept: 'Aceptar',
    decline: 'Rechazar',
    scanQR: 'Escanear QR',
    openDocuments: 'Documentos',
    uploadPOD: 'Subir POD',
    reportDelay: 'Informar retraso',
    actions: {
      assign: 'Asignar',
      viewDetails: 'Ver detalles',
      accept: 'Aceptar',
      decline: 'Rechazar',
      refuse: 'Rechazar',
      scanQR: 'Escanear QR',
      documents: 'Documentos',
      viewDocuments: 'Ver documentos',
      reportDelay: 'Informar retraso',
      route: 'Ruta',
    },
    history: 'Historial',
    inProgress: 'En curso',
    card: {
      orderNumber: 'Pedido Nº',
      from: 'Desde',
      to: 'Hasta',
      order: 'Pedido',
      weight: 'Peso',
      type: 'Tipo',
      price: 'Precio',
      driver: 'Conductor:',
      vehicle: 'Vehículo:',
      assign: 'Asignar',
      pickup: 'Recogida',
      delivery: 'Entrega',
      cargo: 'Carga',
      notAssigned: 'No asignado',
      assignDriver: 'Asignar conductor',
      delayReported: 'Retraso informado',
      status: {
        completed: 'Completada',
        inProgress: 'En curso',
        assigned: 'Asignada',
        pending: 'Pendiente',
      },
    },
    empty: {
      assigned: 'No hay misiones asignadas',
      active: 'No hay misiones activas',
      completed: 'No hay misiones completadas',
    },
  },

  // Billing
  billing: {
    title: 'Facturación',
    detailsTitle: 'Detalles',
    subtitle: 'Gestiona tus órdenes de compra y facturas',
    filterByStatus: 'Filtrar por estado',
    allStatuses: 'Todos los estados',
    documentType: 'Tipo de documento',
    documentNumber: 'Número',
    amount: 'Importe sin IVA',
    vatRate: 'Tasa de IVA',
    vatAmount: 'Importe IVA',
    totalAmount: 'Total con IVA',
    issueDate: 'Fecha de emisión',
    dueDate: 'Fecha de vencimiento',
    paidDate: 'Fecha de pago',
    types: {
      order_form: 'Orden de compra',
      invoice: 'Factura',
    },
    stats: {
      title: 'Resumen',
      totalInvoiced: 'Total facturado',
      totalPaid: 'Total pagado',
      totalPending: 'Pendiente',
      paymentProgress: 'Progreso de pagos',
    },
    statuses: {
      draft: 'Borrador',
      sent: 'Enviado',
      paid: 'Pagado',
      cancelled: 'Cancelado',
    },
    tabs: {
      orderForms: 'Órdenes de compra',
      invoices: 'Facturas',
    },
    emptyStates: {
      orderForms: {
        title: 'No hay órdenes de compra',
        description: 'Las órdenes de compra aparecerán aquí una vez generadas.',
      },
      invoices: {
        title: 'No hay facturas',
        description: 'Las facturas aparecerán aquí una vez generadas.',
      },
    },
    messages: {
      pdfSuccess: 'PDF descargado con éxito',
      pdfError: 'Error al generar el PDF',
      markedAsPaid: 'Documento marcado como pagado',
      titleRequired: 'El título no puede estar vacío',
      titleUpdated: 'Título actualizado correctamente',
    },
    status: {
      paid: 'Pagado',
      sent: 'Enviado',
      cancelled: 'Cancelado',
      draft: 'Borrador',
    },
    documentTypes: {
      orderForm: 'Orden de compra',
      invoice: 'Factura',
    },
    card: {
      order: 'Pedido:',
      route: 'Ruta:',
      amountHT: 'Importe sin IVA',
      vat: 'IVA',
      totalTTC: 'Total con IVA',
      issuedOn: 'Emitido el:',
      dueDate: 'Fecha de vencimiento:',
      paidOn: 'Pagado el:',
      view: 'Ver',
      pdf: 'PDF',
    },
    dialog: {
      documentNumber: 'Número de documento',
      customTitle: 'Título personalizado',
      noTitle: 'Sin título',
      titlePlaceholder: 'Ingrese un título para este documento',
      shipper: 'Remitente',
      transporter: 'Transportista',
      orderDetails: 'Detalles del pedido',
      orderNumber: 'Número de pedido:',
      cargo: 'Carga:',
      route: 'Ruta:',
      financialDetails: 'Detalles financieros',
      amountHT: 'Importe sin IVA',
      vat: 'IVA',
      totalTTC: 'Total con IVA',
      importantDates: 'Fechas importantes',
      issueDate: 'Fecha de emisión',
      dueDate: 'Fecha de vencimiento',
      paymentDate: 'Fecha de pago',
      notes: 'Notas',
      markAsPaid: 'Marcar como pagado',
      downloadPDF: 'Descargar PDF',
    },
    orderForms: 'Órdenes de compra',
    invoices: 'Facturas',
    noDocuments: 'No hay documentos',
    date: 'Fecha',
    paid: 'Pagado',
    unpaid: 'No pagado',
    overdue: 'Vencido',
    markAsPaid: 'Marcar como pagado',
    viewDocument: 'Ver documento',
    downloadPDF: 'Descargar PDF',
    details: {
      shipper: 'Remitente',
      transporter: 'Transportista',
      orderDetails: 'Detalles del pedido',
      route: 'Ruta',
      cargo: 'Carga',
      financial: 'Resumen financiero',
      subtotal: 'Subtotal',
      vat: 'IVA',
      total: 'Total con IVA',
      createdAt: 'Creado el',
      dueDate: 'Fecha de vencimiento',
      paidAt: 'Pagado el',
    },
  },

  // Notifications
  notifications: {
    title: 'Notificaciones',
    markAllRead: 'Marcar todo como leído',
    markAll: 'Marcar todo',
    noNotifications: 'No hay notificaciones',
    empty: 'No hay notificaciones',
    markAsReadError: 'Error al marcar la notificación como leída',
    markAllAsReadError: 'Error al marcar todas las notificaciones como leídas',
    allMarkedAsRead: 'Todas las notificaciones marcadas como leídas',
    notificationNotFound: 'No se puede encontrar este pedido',
    types: {
      mission_assigned: 'Misión asignada',
      new_bid: 'Nueva oferta',
      bid_accepted: 'Oferta aceptada',
      bid_declined: 'Oferta rechazada',
      order_updated: 'Pedido actualizado',
      mission_started: 'Misión iniciada',
      mission_completed: 'Misión completada',
      payment_received: 'Pago recibido',
      rating_reminder: 'Recordatorio de calificación',
    },
  },

  // Navigation
  nav: {
    dashboard: 'Panel',
    marketplace: 'Marketplace',
    missions: 'Misiones',
    liveMap: 'Mapa en Vivo',
    myMissions: 'Mis Misiones',
    myOrders: 'Mis Pedidos',
    fleet: 'Flota',
    billing: 'Facturación',
    settings: 'Configuraciones',
    logout: 'Cerrar sesión',
  },

  // Tracking
  liveMap: {
    description: 'Rastrea todas tus misiones activas en tiempo real',
    noActiveMissions: 'No hay misiones activas en este momento',
    filters: 'Filtros',
    searchPlaceholder: 'Buscar por número de pedido...',
    noResults: 'Ninguna misión coincide con los filtros',
    dateFilter: 'Período',
    allOrders: 'Todos los pedidos',
    today: 'Hoy',
    last7Days: 'Últimos 7 días',
    last30Days: 'Últimos 30 días',
    last90Days: 'Últimos 90 días',
    last365Days: 'Últimos 365 días',
  },

  tracking: {
    title: 'Seguimiento de pedido',
    orderNotFound: 'Pedido no encontrado',
    returnToDashboard: 'Volver al panel',
    deliveryDocuments: 'Documentos de entrega',
    trackingHistory: 'Historial de seguimiento',
    trackingMap: 'Mapa de seguimiento',
    noEvents: 'No hay eventos de seguimiento aún',
    interactiveMap: 'Mapa interactivo',
    noCoordinates: 'Coordenadas GPS no disponibles para este pedido',
    events: {
      pickup_confirmed: 'Recogida confirmada',
      in_transit: 'En tránsito',
      delivered: 'Entregado',
      exception: 'Excepción',
    },
  },

  // Settings
  settings: {
    companyDocuments: {
      title: 'Documentos añadidos por Velox',
      description: 'Documentos adjuntados a su empresa por el equipo de Velox.',
      empty: 'Aún no se ha añadido ningún documento.',
    },
    title: 'Configuración',
    subtitle: 'Gestiona tu información personal y de cuenta',
    tabs: {
      profile: 'Perfil',
      company: 'Empresa',
      language: 'Idioma',
      email: 'Correo',
      password: 'Contraseña',
      notifications: 'Notificaciones',
    },
    profile: {
      title: 'Información personal',
      description: 'Actualiza tu información personal',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Teléfono',
      save: 'Guardar cambios',
      companyLogo: 'Logo de la empresa',
      profilePhoto: 'Foto de perfil',
      changeImage: 'Cambiar imagen',
      imageHint: 'JPG, PNG o WebP. Máx 2 MB.',
      imageUploadSuccess: 'Imagen actualizada con éxito',
      imageUploadError: 'Error al subir la imagen',
      imageTypeError: 'Formato no soportado. Usa JPG, PNG o WebP.',
      imageSizeError: 'El archivo es demasiado grande. Máximo 2 MB.',
    },
    company: {
      title: 'Información de la empresa',
      description: 'Gestiona la información de tu empresa',
      name: 'Nombre de la empresa',
      registrationNumber: 'Número de identificación fiscal',
      registrationNumberDescription: 'SIRET, número de IVA, o identificador fiscal según tu país',
      iban: 'IBAN (opcional)',
      ibanPlaceholder: 'ES91 2100 0418 4502 0005 1332',
      ibanDescription: 'Se utiliza para pagos y facturación. Puede añadirlo más tarde.',
      ibanInvalid: 'IBAN no válido',
      address: 'Dirección',
      phone: 'Teléfono',
      save: 'Guardar cambios',
    },
    language: {
      title: 'Idioma de la interfaz',
      description: 'Elige tu idioma preferido',
      label: 'Idioma',
      note: 'El idioma se aplicará a toda la interfaz',
    },
    email: {
      title: 'Dirección de correo',
      description: 'Modifica tu correo de inicio de sesión',
      newEmail: 'Nueva dirección de correo',
      update: 'Actualizar correo',
      notifications: {
        label: 'Notificaciones por correo',
        description: 'Recibir notificaciones importantes por correo',
      },
    },
    password: {
      title: 'Contraseña',
      description: 'Cambia tu contraseña de inicio de sesión',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Confirmar contraseña',
      save: 'Cambiar contraseña',
    },
    notifications: {
      title: 'Notificaciones',
      description: 'Gestiona tus preferencias de notificaciones',
      emailLabel: 'Notificaciones por correo',
      emailDescription: 'Recibir notificaciones por correo electrónico',
    },
    validation: {
      firstNameRequired: 'El nombre es obligatorio',
      lastNameRequired: 'El apellido es obligatorio',
      companyNameRequired: 'El nombre de la empresa es obligatorio',
      maxLength: 'Máximo {{max}} caracteres',
      emailInvalid: 'Correo inválido',
      passwordMin: 'Mínimo 6 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
    },
    messages: {
      profileUpdated: 'Perfil actualizado con éxito',
      profileError: 'Error al actualizar el perfil',
      companyUpdated: 'Empresa actualizada con éxito',
      companyError: 'Error al actualizar la empresa',
      emailSent: 'Correo de confirmación enviado',
      emailError: 'Error al actualizar el correo',
      currentPasswordIncorrect: 'La contraseña actual es incorrecta',
      passwordUpdated: 'Contraseña actualizada con éxito',
      passwordError: 'Error al actualizar la contraseña',
      languageUpdated: 'Idioma actualizado con éxito',
      languageError: 'Error al actualizar el idioma',
      emailPreferencesUpdated: 'Preferencias de notificaciones actualizadas',
      notificationsUpdated: 'Preferencias de notificaciones actualizadas',
      notificationsError: 'Error al actualizar las notificaciones',
    },
  },

  // Vehicle Types (Trailer Types)
  vehicleTypes: {
    van: 'Furgoneta',
    flatbed: 'Plataforma',
    refrigerated: 'Frigorífico',
    tanker: 'Cisterna',
    curtainsider: 'Lona',
    lowloader: 'Cama baja',
    container: 'Portacontenedor',
    any: 'Cualquier tipo',
    car: 'Portacoches',
    van_small: 'Furgoneta pequeña',
    utility: 'Utilitario',
    other: 'Otro',
  },

  // Admin
  admin: {
    title: 'Panel de Administración',
    unpaidPayments: 'Pagos pendientes',
    auditLogs: 'Registros de auditoría',
    allPaid: 'Todos los pagos están al día',
    noPendingOrders: 'No hay pagos pendientes',
    transporter: 'Transportista',
    orders: 'Pedidos',
    totalAmount: 'Cantidad total',
    action: 'Acción',
    markPaid: 'Marcar como pagado',
    confirmPayment: 'Confirmar pago',
    confirmPaymentText:
      '¿Estás seguro de que deseas marcar como pagados los {{count}} pedido(s) de {{name}} por un total de {{amount}} €?',
    recording: 'Registrando...',
    cancel: 'Cancelar',
    filters: 'Filtros',
    reset: 'Restablecer',
    table: 'Tabla',
    allTables: 'Todas las tablas',
    allActions: 'Todas las acciones',
    dateFrom: 'Fecha inicio',
    dateTo: 'Fecha fin',
    noAuditLogs: 'No se encontraron registros de auditoría',
    tryModifyFilters: 'Intenta modificar tus filtros',
    logsWillAppear: 'Los registros aparecerán aquí',
    timestamp: 'Marca de tiempo',
    user: 'Usuario',
    details: 'Detalles',
    system: 'Sistema',
    oldValues: 'Valores antiguos',
    newValues: 'Valores nuevos',
    clickToSee: 'Haz clic para ver',
    
    // Navigation
    nav: {
      dashboard: 'Panel',
      users: 'Usuarios y Empresas',
      orders: 'Pedidos',
      invoices: 'Facturas',
      stats: 'Estadísticas',
    },
    
    // Dashboard
    dashboard: {
      title: 'Panel de Administración',
      subtitle: 'Visión general de la plataforma',
      filters: {
        day: 'Hoy',
        week: 'Esta semana',
        month: 'Este mes',
      },
      revenue: 'Ingresos',
      ordersDelivered: 'Pedidos entregados',
      ordersPosted: 'Pedidos publicados',
      ordersInProgress: 'En curso',
      vsLastPeriod: 'vs. período anterior',
      vsAverage: 'vs. promedio',
      revenueChart: 'Evolución de ingresos',
      ordersChart: 'Evolución de pedidos',
    },
    
    // Users & Companies
    users: {
      title: 'Usuarios y Empresas',
      subtitle: 'Gestión de usuarios y empresas',
      name: 'Nombre',
      email: 'Email',
      company: 'Empresa',
      role: 'Rol',
      status: 'Estado',
      registrationDate: 'Fecha de registro',
      actions: 'Acciones',
      suspend: 'Suspender',
      delete: 'Eliminar',
      promoteAdmin: 'Promover a admin',
      viewDetails: 'Ver detalles',
      filters: {
        role: 'Filtrar por rol',
        status: 'Filtrar por estado',
        company: 'Filtrar por empresa',
        date: 'Filtrar por fecha',
        allRoles: 'Todos los roles',
        allStatuses: 'Todos los estados',
        allCompanies: 'Todas las empresas',
      },
      statuses: {
        active: 'Activo',
        suspended: 'Suspendido',
        deleted: 'Eliminado',
      },
      showDeleted: 'Mostrar cuentas eliminadas',
      deletedHiddenCount: '{{count}} cuenta(s) eliminada(s) oculta(s)',
      userDetails: {
        title: 'Detalles del usuario',
        personalInfo: 'Información personal',
        companyInfo: 'Información de la empresa',
        phone: 'Teléfono',
        language: 'Idioma preferido',
        emailNotifications: 'Notificaciones por email',
        enabled: 'Activadas',
        disabled: 'Desactivadas',
      },
      companyDetails: {
        createdAt: 'Creada el',
        companyCreatedSince: 'Desde el {{date}}',
        title: 'Detalles de la empresa',
        type: 'Tipo',
        siret: 'SIRET',
        address: 'Dirección',
        users: 'Usuarios asociados',
        fleet: 'Flota',
        drivers: 'Conductores',
        documents: 'Documentos',
        vehicleCount: 'Vehículos',
        driverCount: 'Conductores',
        documentStatus: 'Estado de documentos',
        valid: 'Válidos',
        expired: 'Expirados',
        missing: 'Faltantes',
      },
      confirmSuspend: 'Confirmar suspensión',
      confirmSuspendMessage: '¿Está seguro de que desea suspender este usuario?',
      confirmDelete: 'Eliminar definitivamente esta cuenta',
      confirmDeleteMessage: 'La cuenta será anonimizada: los datos personales se borran y el acceso queda bloqueado definitivamente. El historial de pedidos se conserva. Esta acción es irreversible.',
      deleteSuccess: 'Cuenta eliminada y anonimizada',
      deleteError: 'Error al eliminar la cuenta',
      confirmPromote: 'Confirmar promoción',
      confirmPromoteMessage: '¿Está seguro de que desea promover este usuario a administrador?',
      userSuspended: 'Usuario suspendido',
      userDeleted: 'Usuario eliminado',
      userPromoted: 'Usuario promovido a administrador',
      error: 'Ocurrió un error',
    },
    
    // Orders
    adminOrders: {
      title: 'Pedidos',
      subtitle: 'Gestión de pedidos',
      orderId: 'ID de pedido',
      shipper: 'Remitente',
      transporter: 'Transportista',
      amount: 'Monto',
      status: 'Estado',
      date: 'Fecha',
      actions: 'Acciones',
      viewDetails: 'Ver detalles',
      markDelivered: 'Marcar como entregado',
      cancelOrder: 'Cancelar',
      viewInvoice: 'Ver factura',
      filters: {
        status: 'Filtrar por estado',
        date: 'Filtrar por fecha',
        shipper: 'Filtrar por remitente',
        transporter: 'Filtrar por transportista',
        allStatuses: 'Todos los estados',
      },
      orderDetails: {
        title: 'Detalles del pedido',
        route: 'Ruta',
        cargo: 'Carga',
        pricing: 'Precio',
        documents: 'Documentos',
        tracking: 'Seguimiento',
      },
      confirmMarkDelivered: 'Confirmar entrega',
      confirmMarkDeliveredMessage: '¿Está seguro de que desea marcar este pedido como entregado?',
      confirmCancel: 'Confirmar cancelación',
      confirmCancelMessage: '¿Está seguro de que desea cancelar este pedido?',
      orderMarkedDelivered: 'Pedido marcado como entregado',
      orderCancelled: 'Pedido cancelado',
      error: 'Ocurrió un error',
    },
    
    // Invoices
    invoices: {
      title: 'Facturas',
      subtitle: 'Gestión de facturas',
      invoiceId: 'ID de factura',
      shipper: 'Remitente',
      transporter: 'Transportista',
      amount: 'Monto',
      status: 'Estado',
      date: 'Fecha',
      actions: 'Acciones',
      markPaidAction: 'Marcar como pagada',
      report: 'Reportar',
      viewDetails: 'Ver detalles',
      statuses: {
        pending: 'Pendiente',
        paid: 'Pagada',
        reported: 'Reportada',
        cancelled: 'Cancelada',
      },
      invoiceDetails: {
        title: 'Detalles de la factura',
        shipperInfo: 'Información del remitente',
        transporterInfo: 'Información del transportista',
        orderInfo: 'Información del pedido',
        history: 'Historial',
        comments: 'Comentarios del admin',
        addComment: 'Agregar comentario',
      },
      confirmMarkPaid: 'Confirmar pago',
      confirmMarkPaidMessage: '¿Está seguro de que desea marcar esta factura como pagada?',
      confirmReport: 'Reportar factura',
      confirmReportMessage: '¿Está seguro de que desea reportar esta factura?',
      confirmCancel: 'Cancelar factura',
      confirmCancelMessage: '¿Está seguro de que desea cancelar esta factura? Esta acción es irreversible.',
      reportReason: 'Motivo del reporte',
      invoiceMarkedPaid: 'Factura marcada como pagada',
      invoiceReported: 'Factura reportada',
      commentAdded: 'Comentario agregado',
      error: 'Ocurrió un error',
    },
  },

  // Shipper
  shipper: {
    dashboard: {
      title: 'Panel de Remitente',
      createOrder: 'Crear pedido',
      pendingReservations: 'Reservas pendientes de confirmación',
      pendingReservationsSubtitle:
        '{{count}} transportista(s) han reservado tus pedidos',
      pendingBids: 'Ofertas Recibidas',
      pendingBidsSubtitle: 'Tienes {{count}} oferta(s) esperando validación',
      ordersInProgress: 'Pedidos en curso',
      ordersInProgressSubtitle: 'Tus pedidos asignados y en tránsito',
      viewAllOrders: 'Ver todos mis pedidos',
      noOrdersInProgress: 'No hay pedidos en curso',
    },
    stats: {
      totalOrders: 'Total de pedidos',
      inProgress: 'En curso',
      delivered: 'Entregados',
      drafts: 'Borradores',
    },
    reservation: {
      pending: 'Reserva pendiente',
      transporter: 'Transportista',
      confirming: 'Confirmando...',
      confirm: 'Confirmar',
      declining: 'Rechazando...',
      decline: 'Rechazar',
    },
    bids: {
      order: 'Pedido',
      pickup: 'Recogida',
      delivery: 'Entrega',
      transporter: 'Transportista',
      proposedAmount: 'Monto Propuesto',
      message: 'Mensaje',
      submittedOn: 'Enviado el',
    },
    messages: {
      reservationConfirmed: 'Reserva confirmada con éxito',
      reservationDeclined: 'Reserva rechazada',
      bidAccepted: 'Oferta aceptada con éxito',
      bidDeclined: 'Oferta rechazada',
    },
    errors: {
      confirmError: 'Error al confirmar reserva',
      declineError: 'Error al rechazar reserva',
      acceptBidError: 'Error al aceptar la oferta',
      declineBidError: 'Error al rechazar la oferta',
    },
  },

  // Transporter
  transporter: {
    dashboard: {
      title: 'Panel de Transportista',
      activeMissions: 'Misiones activas',
      noActiveMissions: 'No hay misiones activas',
      checkMarketplace: 'Consulta el marketplace para reservar misiones',
      cancelMissionConfirm:
        '¿Deseas realmente cancelar la misión {{orderNumber}}?',
    },
    stats: {
      availableVehicles: 'Vehículos disponibles',
      activeMissions: 'Misiones en curso',
      availableDrivers: 'Conductores disponibles',
      completedMissions: 'Misiones completadas',
    },
    mission: {
      pendingConfirmation: 'Pendiente de confirmación',
      assigned: 'Asignada',
      accepted: 'Aceptada',
      pickup: 'Recogida',
      delivery: 'Entrega',
      driver: 'Conductor:',
      vehicle: 'Vehículo:',
    },
    messages: {
      missionCanceled: 'Misión cancelada con éxito',
    },
  },

  // Landing
  landing: {
    hero: {
      title: 'Velox',
      titleHighlight: 'gestiona tus misiones de transporte,',
      titleEnd: 'sin esfuerzo',
      subtitle:
        'Una Progressive Web App optimizada para escritorio y móvil: publica carga, accede al marketplace, asigna conductores, valida mediante código QR y gestiona pagos — todo en un solo lugar.',
      tryFree: 'Probar gratis',
      learnMore: 'Saber más',
      cta: 'Registrarse',
    },
    allYouNeed: {
      title: 'Todo lo que necesitas',
      subtitle:
        'Una plataforma completa para gestionar eficientemente tu actividad de transporte',
    },
    features: {
      title: 'Funciones clave',
      shipments: {
        title: 'Gestión de envíos',
        description: 'Crea, rastrea y gestiona tus pedidos de transporte en tiempo real con una interfaz intuitiva.',
      },
      fleet: {
        title: 'Gestión de flota',
        description: 'Optimiza el uso de tus vehículos y conductores con herramientas de planificación avanzadas.',
      },
      tracking: {
        title: 'Seguimiento en tiempo real',
        description: 'Localiza tus entregas en directo y mantén a tus clientes informados en cada paso.',
      },
      multiUser: {
        title: 'Multiusuario',
        description: 'Colabora eficazmente con tu equipo gracias a roles y permisos personalizados.',
      },
      planning: {
        title: 'Planificación inteligente',
        description: 'Optimiza tus rutas y planifica tus misiones con algoritmos inteligentes.',
      },
      security: {
        title: 'Máxima seguridad',
        description: 'Tus datos están protegidos con los estándares de seguridad más altos.',
      },
    },
    workflow: {
      title: 'Flujo de trabajo principal',
      subtitle: 'V1 - flujo completo de marketplace y proceso',
      steps: {
        step1: {
          badge: 'Paso 1',
          title: 'Publicación de carga (Remitente)',
          description: 'Creación de cuenta empresarial, configuración del pedido (tipo de remolque, destino, ventana de entrega, precio propuesto). El pedido aparece en el marketplace.',
        },
        step2: {
          badge: 'Paso 2',
          title: 'Selección y reserva (Transportista)',
          description: 'Registro del transportista e integración de conductores. Marketplace con filtros (ruta, tipo de carga, distancia). Reserva y confirmación de la carga.',
        },
        step3: {
          badge: 'Paso 3',
          title: 'Asignación de conductor',
          description: 'Enlace automático enviado para la creación de cuenta de conductor vinculada a la empresa. El conductor acepta la misión a través de la PWA.',
        },
        step4: {
          badge: 'Paso 4',
          title: 'Carga y salida',
          description: 'El conductor se registra en el sitio de carga. Validación mediante código QR o confirmación manual → el estado cambia a "en tránsito".',
        },
        step5: {
          badge: 'Paso 5',
          title: 'Entrega',
          description: 'Validación mediante código QR o botón "Entregado". Carga de fotos y documentos POD/CMR. Las notificaciones se envían instantáneamente, estado actualizado en el panel.',
        },
        step6: {
          badge: 'Paso 6',
          title: 'Pago y cierre',
          description: 'El administrador valida los pedidos entregados para los pagos diarios. La factura se genera automáticamente. El remitente recibe la factura y califica al transportista.',
        },
      },
    },
    comparison: {
      title: "Encuentra la solución que te conviene",
      subtitle: "Ya seas expedidor o transportista, Velox simplifica la gestión de tus operaciones de transporte",
      shipper: {
        title: "Expedidores",
        benefits: [
          "Publica tus pedidos de carga en pocos clics",
          "Accede a una red de transportistas verificados",
          "Rastrea tus entregas en tiempo real",
          "Gestiona tus facturas y pagos fácilmente",
          "Benefíciate de un servicio al cliente dedicado"
        ],
        cta: "Comenzar como expedidor"
      },
      transporter: {
        title: "Transportistas",
        benefits: [
          "Accede a miles de ofertas de carga",
          "Optimiza la utilización de tu flota",
          "Gestiona tus conductores y vehículos fácilmente",
          "Recibe tus pagos rápidamente",
          "Desarrolla tu negocio eficientemente"
        ],
        cta: "Comenzar como transportista"
      }
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber sobre Velox',
      questions: {
        whatIsVelox: {
          question: '¿Qué es Velox?',
          answer: 'Velox es una Progressive Web App diseñada para simplificar la gestión de misiones de transporte entre expedidores, transportistas y conductores. Centraliza la publicación de carga, reserva, asignación, validación de entrega y seguimiento de pagos.',
        },
        needDownload: {
          question: '¿Necesito descargar una aplicación?',
          answer: 'No. Velox es una PWA — funciona directamente en navegadores de escritorio y móviles. No se requiere instalación desde App Store o Google Play.',
        },
        whoCanUse: {
          question: '¿Quién puede usar Velox?',
          answer: 'Velox admite tres tipos principales de usuarios: Expedidores (publicar pedidos de carga y rastrear entregas), Transportistas (explorar y reservar carga, asignar misiones a conductores), y Conductores (recibir misiones, validar pasos, cargar documentos de entrega).',
        },
        driverJoin: {
          question: '¿Cómo se unen los conductores a la plataforma?',
          answer: 'Los conductores reciben un enlace automático de su transportista. Crean una cuenta de conductor conectada en solo unos pasos.',
        },
        deliveryValidation: {
          question: '¿Cómo se valida la entrega?',
          answer: 'La entrega se puede validar mediante el escaneo de un código QR o un botón de confirmación manual. Los conductores también pueden cargar documentos POD/CMR y fotos directamente.',
        },
        notifications: {
          question: '¿Qué tipo de notificaciones se envían?',
          answer: 'Velox envía notificaciones por correo electrónico a expedidores, transportistas y conductores para eventos clave: reservas, asignaciones de misiones, actualizaciones de estado y confirmaciones de entrega.',
        },
        multilingual: {
          question: '¿Es Velox multilingüe y multidivisa?',
          answer: 'Sí. La PWA admite múltiples idiomas y monedas para adaptarse a diferentes mercados.',
        },
        payment: {
          question: '¿Cómo funciona el pago?',
          answer: 'Una vez que una entrega se marca como completa, el Administrador de Velox la valida para el pago diario. Una factura se genera automáticamente y se envía al expedidor.',
        },
        history: {
          question: '¿Puedo ver mis misiones o envíos anteriores?',
          answer: 'Absolutamente. Velox incluye un historial completo para cada rol: Expedidor (entregas, costos, KPI), Transportista (envíos, calificaciones, preferencias), y Conductor (misiones + todos los documentos relacionados).',
        },
        production: {
          question: '¿Es Velox una aplicación de producción?',
          answer: 'Esta versión es un prototipo (V1) enfocado en el flujo de trabajo principal y las capacidades del marketplace. Se agregarán más funciones en las próximas iteraciones.',
        },
      },
    },
    ctaSection: {
      title: '¿Listo para transformar tu logística?',
      subtitle:
        'Únete a las empresas que optimizan su transporte con Velox',
      createAccount: 'Crear una cuenta gratuita',
    },
    cta: {
      title: '¿Listo para empezar?',
      subtitle: 'Únete hoy',
    },
    footer: {
      copyright: '© 2025 Velox. Todos los derechos reservados.',
    },
  },

  // Not Found
  notFound: {
    message: '¡Vaya! Página no encontrada',
    backToHome: 'Volver al inicio',
  },

  // Create Order
  createOrder: {
    title: 'Crear un pedido',
    subtitle: 'Complete la información de su transporte',
    
    section1: {
      title: '1. Itinerario',
      description: 'Información de recogida y entrega',
      pickup: 'Recogida',
      delivery: 'Entrega',
    },
    
    address: {
      streetNumber: 'Número',
      streetName: 'Nombre de calle',
      postalCode: 'Código postal',
      city: 'Ciudad',
      country: 'País',
      streetNumberPlaceholder: '123',
      streetNamePlaceholder: 'Calle de la República',
      postalCodePlaceholder: '75000',
      cityPlaceholder: 'París',
      countryPlaceholder: 'Francia',
    },
    
    dateTime: {
      pickupDate: 'Fecha de recogida',
      pickupTime: 'Hora de recogida',
      deliveryDate: 'Fecha de entrega',
      deliveryTime: 'Hora de entrega',
      chooseDate: 'Elegir una fecha',
    },
    
    contact: {
      label: 'Contacto',
      phone: 'Teléfono',
      contactPlaceholder: 'Juan Pérez',
      phonePlaceholder: '6 12 34 56 78',
    },
    
    access: {
      detailsLabel: 'Detalles de acceso (opcional)',
      detailsPlaceholder: 'Ej: Código puerta 1234, Entrada por parking trasero, Llamar oficina 3...',
      detailsHelper: 'Especifique los detalles para acceder al lugar de recogida',
      deliveryDetailsPlaceholder: 'Ej: Timbre 2º piso, Entrega por calle, Acceso parking visitantes...',
      deliveryDetailsHelper: 'Especifique los detalles para acceder al lugar de entrega',
      photosLabel: 'Fotos de acceso (opcional)',
      photosHelper: 'Máximo 5 imágenes para ayudar a encontrar el lugar de recogida',
      deliveryPhotosHelper: 'Máximo 5 imágenes para ayudar a encontrar el lugar de entrega',
      maxImagesError: 'Máximo 5 imágenes permitidas',
    },
    
    gps: {
      calculating: 'Calculando posición GPS...',
      calculated: 'Posición GPS calculada',
    },
    
    section2: {
      title: '2. Mercancía',
      subtitle: 'Detalles de la carga a transportar',
      cargoTitle: 'Título de la mercancía',
      cargoTitlePlaceholder: 'Ej: Paletas de productos electrónicos, Mobiliario de oficina...',
      vehicleType: 'Tipo de vehículo',
      vehicleTypePlaceholder: 'Seleccionar un tipo',
      anyVehicle: 'Cualquier tipo de vehículo',
      weight: 'Peso (kg)',
      weightPlaceholder: '1000',
      volume: 'Volumen (m³)',
      volumePlaceholder: '10.5',
      unitType: 'Tipo de unidad',
      unitTypePlaceholder: 'Seleccionar un tipo',
      quantity: 'Cantidad',
      quantityPlaceholder: 'Ej: 12',
      cargoDescription: 'Descripción de la mercancía',
      cargoDescriptionPlaceholder: 'Describa la naturaleza de su carga...',
      specialInstructions: 'Instrucciones especiales',
      specialInstructionsPlaceholder: 'Requisitos específicos, restricciones horarias...',
      cargoPhoto: 'Foto de la mercancía (opcional)',
      cargoPhotoHelper: 'Una imagen para ilustrar su mercancía',
    },
    
    unitTypes: {
      palettes: 'Paletas',
      caisses: 'Cajas',
      euroPalettes: 'Euro-paletas',
    },
    
    section3: {
      title: '3. Tarificación',
      subtitle: 'Método de fijación de precios',
      pricingMode: 'Modo de tarificación',
      fixedPrice: 'Precio fijo',
      fixedPriceDesc: 'Usted define el precio de transporte',
      auction: 'Subasta',
      auctionDesc: 'Los transportistas proponen sus tarifas',
      proposedPrice: 'Precio propuesto (€)',
      proposedPricePlaceholder: '850.00',
    },
    
    section4: {
      title: '4. Visibilidad',
      subtitle: 'Publicación del pedido',
      marketplaceVisible: 'Hacer visible en el marketplace',
      marketplaceVisibleDesc: 'Los transportistas podrán ver y enviar ofertas',
    },
    
    actions: {
      saveDraft: 'Guardar borrador',
      createOrder: 'Crear pedido',
      creating: 'Creando...',
    },
    
    toasts: {
      draftSaved: '¡Borrador guardado!',
      orderCreated: '¡Pedido creado y publicado!',
      priceRequired: 'Precio propuesto requerido para publicar el pedido',
      error: 'Error al crear el pedido',
    },
    
    validation: {
      numberTooLong: 'Número demasiado largo',
      streetNameRequired: 'Nombre de calle requerido (mín. 3 caracteres)',
      streetNameTooLong: 'Nombre de calle demasiado largo',
      postalCodeRequired: 'Código postal requerido',
      postalCodeTooLong: 'Código postal demasiado largo',
      cityRequired: 'Ciudad requerida',
      cityTooLong: 'Ciudad demasiado larga',
      countryRequired: 'País requerido',
      countryTooLong: 'País demasiado largo',
      pickupDateRequired: 'Fecha de recogida requerida',
      deliveryDateRequired: 'Fecha de entrega requerida',
      invalidTime: 'Hora inválida (formato HH:MM)',
      contactRequired: 'Nombre de contacto requerido',
      contactTooLong: 'Nombre demasiado largo',
      phoneRequired: 'Teléfono requerido (mín. 8 dígitos)',
      phoneTooLong: 'Teléfono demasiado largo',
      detailsTooLong: 'Detalles demasiado largos',
      cargoTitleRequired: 'Título requerido (mín. 3 caracteres)',
      cargoTitleTooLong: 'Título demasiado largo',
      vehicleTypeRequired: 'Tipo de vehículo requerido',
      weightRequired: 'Peso requerido',
      weightMax: 'Peso máximo 100,000 kg',
      volumeMax: 'Volumen máximo 200 m³',
      quantityNegative: 'La cantidad no puede ser negativa',
      quantityMax: 'Máximo 100',
      descriptionRequired: 'Descripción requerida (mín. 10 caracteres)',
      descriptionTooLong: 'Descripción demasiado larga',
      instructionsTooLong: 'Instrucciones demasiado largas',
      priceRequired: 'Precio requerido',
      priceMax: 'Precio máximo 1.000.000€',
    },
  },

  // Rating System
  rating: {
    title: 'Calificar esta entrega',
    question: '¿Cómo fue esta entrega?',
    comment: 'Comentario (opcional)',
    commentPlaceholder: 'Comparte tu experiencia con este socio...',
    submit: 'Enviar mi calificación',
    submitting: 'Enviando...',
    success: '¡Gracias por tu calificación!',
    error: 'Error al enviar la calificación',
    alreadyRated: 'Ya has calificado este pedido',
    rateDelivery: 'Calificar entrega',
    rateClient: 'Calificar este cliente',
    toRate: 'Por calificar',
    noRatingsYet: 'Sin calificaciones aún',
    
    excellent: '¡Excelente! 🌟',
    veryGood: 'Muy bien 👍',
    good: 'Bien ✓',
    fair: 'Regular',
    poor: 'Insuficiente',
    
    companyProfile: {
      title: 'Calificaciones',
      average: 'Calificación promedio',
      totalReviews: 'reseñas',
      distribution: 'Distribución de calificaciones',
    },
    
    yourRating: 'Tu calificación',
    partnerRating: 'Calificación del socio',
  },

  // Toast
  toast: {
    reservationConfirmed: 'Reserva confirmada con éxito',
    reservationDeclined: 'Reserva rechazada',
    error: 'Se produjo un error',
  },

  // Legal
  legal: {
    termsOfService: {
      title: "Condiciones Generales de Uso",
      lastUpdate: "Última actualización",
      section1: {
        title: "1. Objeto",
        content: "Estas Condiciones Generales de Uso (CGU) definen las modalidades de uso de la plataforma Velox, un servicio de conexión entre remitentes y transportistas. Al utilizar nuestra plataforma, acepta sin reservas estas CGU.",
      },
      section2: {
        title: "2. Registro y Cuenta de Usuario",
        content: "El uso de la plataforma requiere la creación de una cuenta de usuario. Se compromete a proporcionar información precisa y actualizada, incluido su número de NIF/IVA y sus datos bancarios (IBAN). Es responsable de la confidencialidad de sus credenciales de acceso.",
      },
      section3: {
        title: "3. Servicios Ofrecidos",
        content: "Velox conecta a remitentes que necesitan servicios de transporte con transportistas profesionales. La plataforma facilita la creación de pedidos, la presentación de ofertas, el seguimiento en tiempo real y la gestión de facturación. Velox actúa únicamente como intermediario y no es parte del contrato de transporte.",
      },
      section4: {
        title: "4. Obligaciones de los Usuarios",
        content: "Los remitentes se comprometen a proporcionar información precisa sobre sus mercancías. Los transportistas se comprometen a contar con las licencias y seguros necesarios para ejercer su actividad. Todos los usuarios se comprometen a respetar la legislación vigente y a no utilizar la plataforma con fines fraudulentos.",
      },
      section5: {
        title: "5. Tarifas y Pago",
        content: "Los precios se negocian libremente entre remitentes y transportistas. Velox cobra una comisión por cada transacción realizada a través de la plataforma. Los pagos son seguros y se procesan a través de nuestro sistema de pago integrado. Las facturas están disponibles en la sección de facturación.",
      },
      section6: {
        title: "6. Responsabilidades",
        content: "Velox no puede ser responsable de los daños resultantes de la ejecución del contrato de transporte entre el remitente y el transportista. La responsabilidad de Velox se limita a proporcionar la plataforma. En caso de disputa, las partes se comprometen a buscar una solución amistosa antes de cualquier acción legal.",
      },
    },
    privacyPolicy: {
      title: "Política de Privacidad",
      lastUpdate: "Última actualización",
      section1: {
        title: "1. Editor de la Plataforma",
        content: "Velox es editado por [Nombre de la empresa], sociedad por acciones simplificada con un capital de [monto] euros, registrada en el RCS de [ciudad] con el número [número], con sede social en [dirección completa]. Director de publicación: [Nombre]. Contacto: contact@velox.com",
      },
      section2: {
        title: "2. Alojamiento",
        content: "La plataforma Velox está alojada por Supabase Inc., 970 Toa Payoh North, #07-04, Singapore 318992. El servicio utiliza infraestructura en la nube segura con servidores ubicados en Europa (compatible con RGPD).",
      },
      section3: {
        title: "3. Protección de Datos Personales",
        content: "De acuerdo con el RGPD, tiene derecho a acceder, rectificar y eliminar sus datos personales. Los datos recopilados (nombre, correo, teléfono, NIF, IBAN) son necesarios para el funcionamiento del servicio y se almacenan de forma segura. Nunca se comparten con terceros sin su consentimiento.",
      },
      section4: {
        title: "4. Cookies",
        content: "La plataforma utiliza cookies técnicas esenciales para el funcionamiento del servicio (autenticación, preferencias de idioma). No se utilizan cookies publicitarias ni de seguimiento. Puede configurar su navegador para rechazar las cookies, pero esto puede afectar ciertas funcionalidades.",
      },
      section5: {
        title: "5. Propiedad Intelectual",
        content: "Todos los elementos de la plataforma Velox (logos, textos, gráficos, software) están protegidos por derechos de autor y son propiedad exclusiva de Velox. Está prohibida cualquier reproducción, representación o explotación no autorizada.",
      },
      section6: {
        title: "6. Ley Aplicable",
        content: "Estas menciones legales se rigen por la ley francesa. En caso de disputa, los tribunales franceses tendrán jurisdicción exclusiva. Para cualquier pregunta relacionada con las menciones legales, puede contactarnos en: legal@velox.com",
      },
    },
  },
  support: {
    title: 'Soporte Velox',
    description: 'Contacta a nuestro equipo de soporte',
    callVelox: 'Llamar a Velox',
    email: 'Correo',
    phone: 'Teléfono',
    adminTitle: 'Contactos de soporte Velox',
    adminDescription: 'Estos datos se muestran a los usuarios al contactar con soporte.',
  },
  supportChat: {
    title: 'Soporte Velox',
    adminTitle: 'Tickets de soporte',
    adminNav: 'Soporte',
    open: 'Abrir chat',
    yourTickets: 'Tus tickets',
    newTicket: 'Nuevo ticket',
    empty: 'Aún no hay tickets',
    writeMessage: 'Escribir un mensaje…',
    send: 'Enviar',
    skip: 'Omitir este paso',
    pickOrder: 'Selecciona el pedido relacionado:',
    descPlaceholder: 'Describe tu problema o solicitud…',
    selectTicket: 'Selecciona un ticket para ver la conversación',
    markResolved: 'Marcar resuelto',
    close: 'Cerrar',
    assignMe: 'Asignarme',
    filter: { all: 'Todos los estados' },
    status: {
      bot: 'Calificando',
      pending_admin: 'Pendiente',
      open: 'Abierto',
      resolved: 'Resuelto',
      closed: 'Cerrado',
    },
    cat: {
      offer: 'Una oferta',
      mission: 'Una misión',
      account: 'Mi cuenta',
      payment: 'Pago / facturación',
      other: 'Otro',
    },
    bot: {
      greeting: 'Hola 👋 Soy el asistente de Velox. Te dirigiré a la persona adecuada.',
      askCategory: '¿Sobre qué quieres contactarnos?',
      askContext: '¿A qué pedido se refiere tu solicitud? (también puedes omitir este paso)',
      askDescription: 'Describe tu solicitud en pocas palabras y nuestro equipo te responderá pronto.',
      handoff: '¡Gracias! Un miembro del equipo Velox tomará el relevo y te responderá lo antes posible.',
    },
  },
  adminCreate: {
    navShort: 'Crear cuenta',
    title: 'Crear una cuenta',
    subtitle: 'Crea una empresa cargadora, transportista o añade un conductor a una empresa existente.',
    tabs: {
      shipper: 'Empresa cargadora',
      transporter: 'Empresa transportista',
      driver: 'Conductor',
      admin: 'Administrador',
    },
    sections: {
      company: 'Información de la empresa',
      ownerInfo: 'Propietario de la cuenta',
      driverInfo: 'Información del conductor',
      adminInfo: 'Información del administrador',
      attachToTransporter: 'Empresa transportista',
      activation: 'Activación de la cuenta',
    },
    fields: {
      foundedDate: 'Fecha de fundación',
      companyName: 'Nombre de la empresa',
      companyPhone: 'Teléfono empresa',
      transporter: 'Empresa transportista',
      transporterPlaceholder: 'Seleccionar una empresa',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo',
      phone: 'Teléfono',
      password: 'Contraseña temporal',
      passwordPlaceholder: 'Al menos 8 caracteres',
      passwordHint: 'El usuario podrá cambiarla después de iniciar sesión.',
    },
    mode: {
      invite: {
        label: 'Enviar una invitación por correo',
        desc: 'El usuario recibe un enlace para definir su contraseña y activar la cuenta.',
      },
      direct: {
        label: 'Crear directamente con contraseña',
        desc: 'La cuenta queda activa de inmediato. Comparte la contraseña con la persona.',
      },
    },
    submit: {
      invite: 'Enviar invitación',
      direct: 'Crear cuenta',
    },
    success: {
      invite: 'Invitación enviada con éxito.',
      direct: 'Cuenta creada con éxito.',
    },
    errors: {
      missingUser: 'Completa todos los campos del usuario.',
      missingCompany: 'Completa el nombre y teléfono de la empresa.',
      pickCompany: 'Selecciona una empresa transportista.',
      shortPassword: 'La contraseña debe tener al menos 8 caracteres.',
      emailTaken: 'Esta dirección de correo ya pertenece a una cuenta existente. No se creó ninguna cuenta ni se envió ningún correo.',
      generic: 'Error al crear la cuenta.',
    },
  },
  emailTemplates: {
    tab: 'Emails',
    title: 'Plantillas de email',
    description: 'Personaliza los emails enviados al crear cuentas.',
    invitation: 'Invitación (activación por usuario)',
    passwordReset: 'Restablecer contraseña',
    signupWelcome: "Bienvenida (registro)",
    emailChange: "Cambio de dirección de correo",
    directWelcome: 'Bienvenida (creación directa)',
    subject: 'Asunto',
    bodyHtml: 'Contenido HTML',
    enabled: 'Email activado',
    enabledHint: 'Si está desactivado, no se enviará ningún email.',
    bccAdmin: 'Copia oculta (BCC) al admin',
    bccAdminHint: 'Recibir una copia oculta de cada email.',
    variables: 'Variables disponibles',
  },
  adminDocuments: {
    docSearchPlaceholder: 'Buscar un documento (archivo, categoría, pedido, matrícula, conductor)...',
    categoryAll: 'Todas las categorías',
    statusAll: 'Todos los estados',
    resetFilters: 'Restablecer',
    noResults: 'Ningún documento coincide con su búsqueda.',
    companiesShown_one: '{{count}} empresa mostrada',
    companiesShown_other: '{{count}} empresas mostradas',
    addedByVelox: 'Añadido por Velox',
    categories: {
      kyc: 'KYC / identidad',
      insurance_license: 'Seguro y licencia',
      contract: 'Contrato / comercial',
      registration_card: 'Permiso de circulación',
      inspection: 'Inspección técnica',
      driver_license: 'Permiso de conducir',
      loading_photos: 'Fotos de carga',
      delivery_photos: 'Fotos de entrega',
      cmr: 'CMR / albarán',
      other: 'Otro',
    },
    add: {
      button: 'Añadir un documento',
      buttonShort: 'Añadir',
      title: 'Añadir un documento',
      description: 'Este documento se adjuntará a {{company}} y será visible para esa empresa.',
      scope: 'Adjuntar a',
      scopeCompany: 'La empresa (onboarding)',
      scopeOrder: 'Un pedido (carga)',
        scopeVehicle: 'Un vehículo',
        scopeDriver: 'Un conductor',
        vehicle: 'Vehículo',
        vehicleSearch: 'Buscar un vehículo...',
        vehiclePlaceholder: 'Seleccionar un vehículo',
        noVehicles: 'Esta empresa aún no tiene ningún vehículo registrado.',
        noDrivers: 'Esta empresa aún no tiene ningún conductor registrado.',
        vehicleRequired: 'Seleccione un vehículo.',
        driver: 'Conductor',
        driverSearch: 'Buscar un conductor...',
        driverPlaceholder: 'Seleccionar un conductor',
        driverRequired: 'Seleccione un conductor.',
      order: 'Pedido',
      orderSearch: 'Buscar un pedido...',
      orderPlaceholder: 'Seleccionar un pedido',
      category: 'Categoría',
      label: 'Etiqueta',
      labelPlaceholder: 'Ej. Certificado de seguro 2026',
      expiry: 'Fecha de caducidad (opcional)',
      notes: 'Nota interna (opcional)',
      chooseFile: 'Elegir un archivo',
      fileHint: 'Formatos aceptados: PDF, JPG, PNG (máx. 10 MB)',
      uploading: 'Subiendo...',
      submit: 'Añadir el documento',
      success: 'Documento añadido',
      error: 'No se ha podido añadir el documento',
      invalidType: 'Formato no compatible. Use PDF, JPG o PNG.',
      tooLarge: 'Archivo demasiado grande (máx. 10 MB)',
      fileRequired: 'Seleccione un archivo',
      orderRequired: 'Seleccione un pedido',
      deleteTitle: '¿Eliminar este documento?',
      deleteDescription: '{{name}} se eliminará definitivamente. Esta acción es irreversible.',
      deleteSuccess: 'Documento eliminado',
      deleteError: 'No se ha podido eliminar el documento',
    },
    breadcrumb: 'Documentos',
    shippers: 'Cargadores',
    transporters: 'Transportistas',
    title: 'Documentos de usuarios',
    subtitle: 'Selecciona una empresa para ver sus documentos organizados por categoría.',
    searchPlaceholder: 'Buscar una empresa...',
    noCompanies: 'Ninguna empresa {{side}}.',
    sideShipper: 'cargador',
    sideTransporter: 'transportista',
    usersCount_one: '{{count}} usuario',
    usersCount_other: '{{count}} usuarios',
    docsCount_one: '{{count}} doc',
    docsCount_other: '{{count}} docs',
    expiredCount_one: '{{count}} vencido',
    expiredCount_other: '{{count}} vencidos',
    missingCount_one: '{{count}} faltante',
    missingCount_other: '{{count}} faltantes',
    complete: 'Completo',
    back: 'Volver',
    sectionOnboarding: 'Onboarding',
    sectionFleet: 'Flota',
    sectionFreight: 'Carga',
    onboardingTitle: 'Documentos de onboarding',
    onboardingDesc: 'KBIS, IVA, IBAN, licencia de transporte, seguro RC, condiciones generales…',
    onboardingEmpty: 'No hay documentos de onboarding para esta empresa.',
    fleetTitle: 'Documentos de flota',
    trucks: 'Camiones',
    trailers: 'Remolques',
    drivers: 'Conductores',
    emptyTrucks: 'Sin camiones registrados.',
    emptyTrailers: 'Sin remolques registrados.',
    emptyDrivers: 'Sin conductores registrados.',
    noDocsResource: 'Sin documentos asociados.',
    freightTitle: 'Documentos de carga',
    freightDesc: 'Una entrada por pedido: orden de transporte, CMR / POD, aduana, litigios, fotos.',
    freightEmpty: 'Ningún pedido con documentos.',
    orderLabel: 'Pedido {{number}}',
    noDocs: 'Sin documentos.',
    tableNature: 'Tipo',
    tableFile: 'Archivo',
    tableStatus: 'Estado',
    tableSize: 'Tamaño',
    tableDate: 'Fecha',
    tableAction: 'Acción',
    statusVerified: 'Verificado',
    statusExpiring: 'Por vencer',
    statusExpired: 'Vencido',
    statusUnverified: 'Sin verificar',
    licensePrefix: 'Licencia',
    licenseExpires: 'vence',
    licenseNotSet: 'Licencia no informada',
    openError: 'No se puede abrir el documento',
    natureRegistration: 'Permiso de circulación',
    natureInsurance: 'Seguro',
    natureInspection: 'Inspección técnica',
    natureOther: 'Otro',
    natureCargo: 'Foto de carga',
    natureStart: 'Foto de recogida',
    natureDelivery: 'Foto de entrega',
    natureDocument: 'Documento',
  },
  footer: {
    tagline: 'La plataforma de transporte y carga que conecta expedidores, transportistas y conductores en toda Europa.',
    legalTitle: 'Información legal',
    contactTitle: 'Soporte',
    partnersTitle: 'Nuestros socios',
    copyright: '© 2026 Velox. Todos los derechos reservados.',
    links: {
      about: 'Sobre nosotros',
      terms: 'Términos y condiciones',
      privacy: 'Política de privacidad',
      legalNotice: 'Aviso legal',
      cookiePolicy: 'Política de cookies',
      cookieSettings: 'Configuración de cookies',
    },
    short: {
      about: 'Sobre nosotros',
      terms: 'Términos',
      privacy: 'Privacidad',
      legalNotice: 'Aviso legal',
      cookies: 'Cookies',
      support: 'Soporte',
    },
  },
  legalNotice: {
    back: 'Volver al inicio',
    title: 'Aviso legal',
    lastUpdated: 'Última actualización: enero de 2026',
    sections: {
      publisher: {
        title: 'Editor del sitio',
        body: 'Velox\nPlataforma de gestión de transporte y carga.\nContacto: support@myvelox.eu\nSitio web: https://myvelox.eu',
      },
      hosting: {
        title: 'Alojamiento',
        body: 'El sitio y sus servicios están alojados por proveedores de infraestructura cloud ubicados en la Unión Europea.',
      },
      intellectualProperty: {
        title: 'Propiedad intelectual',
        body: 'Todo el contenido de la plataforma (textos, imágenes, logotipos, código) está protegido por el derecho de propiedad intelectual. Queda prohibida cualquier reproducción o reutilización sin autorización previa por escrito.',
      },
      dataProtection: {
        title: 'Protección de datos',
        body: 'Los datos personales se tratan conforme al RGPD. Para más información, consulte nuestra política de privacidad. Puede ejercer sus derechos de acceso, rectificación y supresión contactando con nuestro soporte.',
      },
      contact: {
        title: 'Contacto',
        body: 'Para cualquier consulta relativa a este aviso legal, contacte con nuestro equipo de soporte desde la aplicación o por correo electrónico.',
      },
    },
  },
  cookies: {
    alwaysOn: 'Siempre activas',
    banner: {
      title: 'Respetamos su privacidad',
      description: 'Utilizamos cookies estrictamente necesarias para el funcionamiento de Velox y, con su consentimiento, cookies funcionales y analíticas.',
      readPolicy: 'Leer la política de cookies',
      customize: 'Personalizar',
      acceptAll: 'Aceptar todo',
      rejectAll: 'Rechazar todo',
      save: 'Guardar mis preferencias',
    },
    categories: {
      necessary: {
        title: 'Cookies estrictamente necesarias',
        description: 'Imprescindibles para el funcionamiento del sitio (sesión, seguridad, memoria de sus preferencias).',
      },
      functional: {
        title: 'Cookies funcionales',
        description: 'Recuerdan sus preferencias, como el idioma seleccionado.',
      },
      analytics: {
        title: 'Cookies analíticas',
        description: 'Nos ayudan a entender cómo se usa el sitio (PostHog) para mejorarlo.',
      },
    },
  },
  invite: {
    title: 'Únete a Velox',
    subtitle: 'Te han invitado a unirte a',
    subtitleRole: 'como',
    email: 'Correo electrónico',
    firstName: 'Nombre',
    lastName: 'Apellido',
    password: 'Contraseña',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    confirmPassword: 'Confirmar contraseña',
    confirmPasswordPlaceholder: 'Repite tu contraseña',
    creating: 'Creando...',
    createAccount: 'Crear mi cuenta',
    invalidTitle: 'Invitación no válida',
    invalidDescription: 'Esta invitación no es válida, ha caducado o ya se ha utilizado. Contacta con quien te invitó.',
    backToLogin: 'Volver al inicio de sesión',
    welcome: '¡Bienvenido!',
    accountConfigured: 'Tu cuenta se ha configurado correctamente.',
    accountReady: 'Cuenta lista',
    pleaseSignIn: 'Inicia sesión con tu nueva contraseña.',
    sentInvitations: 'Invitaciones enviadas',
    statusAccepted: 'Aceptada',
    passwordSet: 'Contraseña creada',
    emailAlreadyUsed: 'Esta dirección ya pertenece a una cuenta ({{company}} — {{role}}). No se envió ningún correo.',
    invitationAlreadyPending: 'Ya hay una invitación pendiente para esta dirección ({{company}}). No se envió ningún correo.',
    errors: {
      expired: 'Esta invitación ha caducado.',
      alreadyAccepted: 'Esta invitación ya se ha utilizado.',
      invalidToken: 'Enlace de invitación no válido.',
      weakPassword: 'La contraseña debe tener al menos 8 caracteres.',
      passwordMismatch: 'Las contraseñas no coinciden.',
      generic: 'No se pudo completar el registro. Inténtalo de nuevo o contacta con soporte.',
    },
  },
  adminInvitations: {
    actions: 'Acciones',
    resend: 'Reenviar invitación',
    resendSuccess: 'Invitación reenviada',
    resendSuccessDescription: 'Se envió un nuevo correo a {{email}}.',
    resendError: 'No se pudo reenviar la invitación.',
    delete: 'Eliminar',
    deleteTitle: '¿Eliminar esta invitación?',
    deleteDescription: 'El enlace de invitación dejará de funcionar inmediatamente. Esta acción es irreversible.',
    deleteSuccess: 'Invitación eliminada',
    deleteError: 'No se pudo eliminar la invitación.',
    searchPlaceholder: 'Buscar una invitación...',
    refresh: 'Actualizar',
    pageInfo: 'Página {{page}} / {{total}} — {{count}} invitación(es)',
    title: 'Invitaciones enviadas',
    empty: 'Todavía no hay invitaciones.',
    person: 'Persona',
    email: 'Correo electrónico',
    company: 'Empresa',
    role: 'Rol',
    sentAt: 'Enviada el',
    expiresAt: 'Caduca el',
    status: 'Estado',
    statuses: {
      pending: 'Pendiente',
      accepted: 'Aceptada',
      expired: 'Caducada',
    },
  },
};
